export default __webpack_public_path__ + "static/media/my-pets-bin.11a3fe51.svg";